import { trackInfraUpltTimingTraceUserInteractions } from "@faire/web-api--source/events/infra/timing/uplt";
import { trackInfraLoadAnimationFramesView } from "@faire/web-api--source/events/infra/view/loadAnimationFrames";

import { getGlobalProperty } from "../globals/getGlobalProperty";

import {
  detectQuietMainThread,
  IQuietMainThreadResult,
} from "./detectQuietMainThread";
import { ReadonlyAbortNotifier } from "./userPerceivedLoadTiming/AbortNotifier";
import {
  ActionName,
  LoadTimingStatus,
  LoadTimingType,
} from "./userPerceivedLoadTiming/types";

const DEFAULT_MAX_QUIET_WINDOW_WAIT_TIME = 1000;
const FRAME_LATENCY_THRESHOLD = 20;
const MAX_FRAMES_TO_SEND = 200;

type PointerEventTypes =
  | "click"
  | "mousedown"
  | "mouseup"
  | "touchstart"
  | "touchend"
  | "pointerdown"
  | "pointerup";

type KeyboardEventTypes = "keydown" | "keyup";

type InputEventTypes = "input" | "change";

type INPEventTypes = PointerEventTypes | KeyboardEventTypes | InputEventTypes;

export type LoadTimeInteractions = {
  type: INPEventTypes;
  time: number;
};

export const trackQuietMainThread = (
  pageName: ActionName,
  loadType: LoadTimingType | undefined,
  abortNotifier?: ReadonlyAbortNotifier<LoadTimingStatus>
) => {
  return detectQuietMainThread(
    DEFAULT_MAX_QUIET_WINDOW_WAIT_TIME,
    FRAME_LATENCY_THRESHOLD,
    abortNotifier,
    ["CLEAN_UP"]
  )
    .then((result: IQuietMainThreadResult) => {
      // Send load time animation frames
      if (!result.frameDurations) {
        return;
      }

      trackInfraLoadAnimationFramesView(
        result.frameDurations
          .slice(0, MAX_FRAMES_TO_SEND)
          .map((n) => n.toFixed(1))
          .toString(),
        `${result.startOfTracking}`,
        result.status,
        pageName,
        loadType,
        result.status
      );

      const loadTimeInteractions = getGlobalProperty("loadTimeInteractions") as
        | LoadTimeInteractions[]
        | undefined;

      trackInfraUpltTimingTraceUserInteractions(
        JSON.stringify(loadTimeInteractions),
        `${result.startOfTracking}`
      );
    })
    .finally(() => {
      const stopLoadTimeInteractionTracking = getGlobalProperty(
        "stopLoadTimeInteractionTracking"
      ) as (() => void) | undefined;
      if (stopLoadTimeInteractionTracking) {
        stopLoadTimeInteractionTracking();
      }
    });
};
